/**
 * TODO:
 * [-] Conectar el login a un store real
 * [-] solicitar las credenciales con Axios
 * [-] Retornar los datos reales del usuario con UserData
 * [-] Obtener los permisos efectivos del usuario y retornar los claims
 * [-] Conectar de alguna manera con un servicio de autorización que use el Vue Router
 * [-] IMPORTANTE: Cambiar el store de localstorage a otro método más seguro (HTTPCookie)?
 * * */

// import axios from "axios";
import jwt_decode from "jwt-decode";
import menuService from "./menuService";
/** Servicio de login,se encargará del consumo para el inicio de sesion */
const loginService = {
  /** Almacenamiento interno de las credenciales */
  userData: {},
  userToken: "",
  userClaims: [],
  parseClaims(token) {
    try {
      var claims = jwt_decode(token);
      this.userToken = token;
      for (var [key, value] of Object.entries(claims)) {
        if (key.includes("http")) {
          let path = key.substring(key.lastIndexOf("/") + 1);
          this.userData[path] = value;
        } else {
          this.userData[key] = value;
        }
      }
      return true;
    } catch (error) {
      return false;
    }
  },
  destroyUserData() {
    try {
      localStorage.removeItem("tkn");
      localStorage.removeItem("user");
      localStorage.removeItem("profile");
    } catch (error) {
      console.log(error);
    }
  },
  persistUserData() {
    try {
      localStorage.setItem("tkn", this.userToken);
      localStorage.setItem("user", this.userData.nameidentifier);
    } catch (error) {
      console.log(error);
    }
  },
  retrieveUserData() {
    let ret = false;

    try {
      var tkn = localStorage["tkn"];
      if (tkn && tkn.length) {
        ret = this.parseClaims(tkn);
      }
    } catch (error) {
      console.log(error);
      ret = false;
    }
    return ret;
  },
  mapUserProfile(data, token) {
    //Mapear el perfil del usuario

    var hasData = data && data.length;
    var localData = data[0];

    if (!hasData) throw "No existe perfil para el usuario.";

    //Mapear por aparte: Roles y Permisos
    var roles = [];
    var menuItems = [];

    localData.roles.forEach((role) => {
      if (role.active) {
        roles.push({ id: role.id, name: role.name });
      }

      role.roleClaims.forEach((claim) => {
        if (claim.claimType === "ModuleAccess") {
          var menu = JSON.parse(claim.claimValue);

          var access = claim.rolePermissions.map((perm) => {
            if (perm.active) {
              return perm.permission;
            }
          });
          menu.access = access;
          menuItems.push(menu);
        }
      }); //foreach de claims
    }); //foreach de roles

    var finalMenu = {};
    //OHG TODO DEBUG MENU:
    try {
      finalMenu = menuService.mapMenuDataFromSource(menuItems);
    } catch (error) {
      console.log(error);
    }

    var profile = {
      id: localData.id,
      name: localData.name,
      active: localData.active,
      roles: roles,
      menuItems: finalMenu
    };

    var tknData = token.split(".");
    var pass = tknData[2];

    var cryptedData = menuService.encryptMenu(JSON.stringify(profile), pass);

    return cryptedData;
  },
  getMenuData() {
    return false;
  },
  loadUserPermissions(user) {
    //validar los datos de los permisos del usuario
    console.log(user);
  },
  /**
   * Valida los datos antes de iniciar el login
   * @function validateLogin
   * @param {Boolean} bDomain - Determina si es autenticación de dominio o no
   * @return {Boolean} - True o false dependiendo si pasa o no la validación
   */
  validateLogin(bDomain) {
    try {
      if (
        this.isEmpty(this.credentials.username) ||
        this.isEmpty(this.credentials.password)
      ) {
        this.loginErrors.push(
          "Debe especificar el Nombre de Usuario y la Contraseña!"
        );
      }
      if (this.isEmpty(this.credentials.domain) && bDomain) {
        this.loginErrors.push("Debe especificar el Dominio!");
      }
      return true;
    } catch (error) {
      return false;
    }
  },

  isEmpty(value) {
    return value == null || value.length === 0;
  }
};

export default loginService;
